import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateServiceList = {
  serviceList: { data: null, loading: false, error: null },
};

export const serviceList = createAsyncThunk('user/serviceList', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .get(`/service/list`)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerServiceList = {
  [serviceList.pending]: (state) => {
    state.serviceList.loading = true;
  },
  [serviceList.fulfilled]: (state, action) => {
    state.serviceList.loading = false;
    state.serviceList.data = action.payload;
    state.serviceList.error = null;
  },
  [serviceList.rejected]: (state, action) => {
    state.serviceList.loading = false;
    state.serviceList.error = action.payload;
  },
};
